module.exports = __webpack_public_path__ + "img/wave_3blue_rgb.acc7a472.png";